import { Component, Input, OnChanges } from "@angular/core";
import { alertSortOptionsByState, defaultAlertInboxSortOptions } from "@app2/alert/constants";
import { DropdownOption } from "@app2/shared/predicate-dropdown-menu.component";
import { SortType, StateParams, StateType } from "@app2/fraud/type-defs";
import { RouterService } from "@app2/shared/services/router.service";
import { Keys, StorageService } from "@app2/shared/services/storage.service";

@Component({
    selector: "alert-inbox-sort-dropdown",
    template: `
        <predicate-dropdown-menu class="sort-dropdown"
                                 label="INBOX_SORT_BY"
                                 [options]="sortOptions"
                                 [initialValue]="selectedSort"
                                 (onSelect)="selectSort($event)">
        </predicate-dropdown-menu>
    `,
})
export class AlertInboxSortDropdownComponent implements OnChanges {



    @Input() selectedSort: SortType;
    @Input() state: StateType;
    sortOptions: DropdownOption<SortType>[] = defaultAlertInboxSortOptions;

    constructor(private readonly router: RouterService,
                private storageService: StorageService) {
    }

    ngOnChanges() {
        if (this.state) {
           this.sortOptions = alertSortOptionsByState[this.state];
        }
    }

    selectSort(selected: DropdownOption<SortType>) {
        if (this.selectedSort === selected.value) {
            return;
        }

        this.storageService.set(Keys.alertSortBy, selected.value);

        this.router.mergeParams<StateParams>({
            sort: <SortType>selected.value,
            selected: undefined,
        });
    }

}
